export function initReadMoreToggles() {
	if (document.documentElement.dataset.readMoreInit === 'true') return;
	document.documentElement.dataset.readMoreInit = 'true';

	document.addEventListener('click', (event) => {
		const toggle = event.target.closest('[data-js="read-more-toggle"]');
		if (!toggle) return;

		event.preventDefault();
		event.stopPropagation();

		const targetId = toggle.getAttribute('aria-controls');
		if (!targetId) return;

		const extended = document.getElementById(targetId);
		if (!extended) return;

		const isOpen = !extended.hasAttribute('hidden');
		if (isOpen) {
			extended.setAttribute('hidden', '');
		} else {
			extended.removeAttribute('hidden');
		}

		const nextExpandedState = !isOpen;
		const labelOpen = toggle.dataset.labelOpen || 'Read less';
		const labelClosed = toggle.dataset.labelClosed || 'Read more';

		toggle.setAttribute('aria-expanded', nextExpandedState ? 'true' : 'false');
		toggle.textContent = nextExpandedState ? labelOpen : labelClosed;
	});
}
